export default {
  id: null,
  settlement_type_id: null,
  vehicle_id: null,
  file_id: null,
  booking_id: null,
  booking_ticket: null,
  transport_type: null,
  from_place_id: "",
  from_place_text: null,
  to_place_id: "",
  to_place_text: null,
  start_date: "",
  end_date: "",
  amount: null,
  amount_in_currency: null,
  currency: "PLN",
  comment: "",
  distance: "",
  google_maps_api_distance: null,
  car_rental_name: null,
  car_rental_vehicle_name: null,
  car_rental_vehicle_model: null
};
